// Common JS File
import Nav from './modules/nav.js'
import AnchorScroll from './modules/anchor-scroll.js'
import { cookiesPopup } from './modules/cookies.js'
import SlickSlider from './modules/slick-slider.js'
import GeneralJS from './modules/general.js'

// Importing Functions
document.addEventListener('DOMContentLoaded', () => {
    new Nav()
    new AnchorScroll()
    cookiesPopup()
    new SlickSlider()
    new GeneralJS()
})